import { z } from "zod";

import { baseSerieSchema } from "@/components/ui/chart/types/common-series.type";
import { stringLocalDateSchema } from "@/utils/time";

export const temporalDataPointSchema = z.object({
  value: z.number().nullable(),
  date: stringLocalDateSchema,
  isComplete: z.boolean(),
});

export const temporalSerieSchema = baseSerieSchema.extend({
  value: z.array(temporalDataPointSchema),
});

export type TTemporalDataPoint = z.infer<typeof temporalDataPointSchema>;
export type TTemporalSerie = z.infer<typeof temporalSerieSchema>;

export type TTemporalDataResponse<KIND extends string> = {
  timeSeries: Array<
    TTemporalSerie & {
      category: KIND;
    }
  >;
};

export type TTemporalDataResponseSerie<KIND extends string> = TTemporalDataResponse<KIND>["timeSeries"][number];
